import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'sidebar-collapsed';

/**
 * État réduit/étendu du menu latéral, persisté d'une navigation à l'autre.
 * Le menu est fermé par défaut (US : « menu par défaut fermé »).
 */
export function useSidebarCollapsed(): {
  collapsed: boolean;
  toggle: () => void;
} {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    return localStorage.getItem(STORAGE_KEY) !== 'false';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  }, [collapsed]);

  const toggle = useCallback(() => {
    setCollapsed((previous) => !previous);
  }, []);

  return { collapsed, toggle };
}

export default useSidebarCollapsed;
